import {SiteEntity} from "../../commons/models/siteEntity.model";

export enum TravelRuleType {
  GLOBAL = 'Global',
  AREA = 'Area'
}

export interface TravelTimeRuleModel extends SiteEntity {
  name: string;
  type?: TravelRuleType;
  travelTimeFactor?: number;
  polygons?: TravelTimePolygonModel[];
  referenceIds?: string[];
}

export interface TravelTimePolygonModel {
  basedOnArea: string,
  id: string,
  polygonVertices: {lng: number, lat: number}[]
}
